import {
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import useFavouriteCategory from "./useFavouriteCategory";
import AddFavouriteCategory from "./AddFavouriteCategory";
import { ImageCard } from "../../Global/ImageCard";

const FavouriteCategory = () => {
  const {
    isLoading,
    isFetching,
    showEditModal,
    paginationOptions,
    favouriteCategoryList,
    favouriteCategoryState,
    closeImageModal,
    handleModal,
    setFvouriteCategoryState,
    handleEditAction,
    updateFavouriteCategoryTableHeadData,
    handleEditColumnsClick,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useFavouriteCategory();
  return (
    <>
      <HeadingGroup
        title="Favourite Category Icon"
        className={`pro-mb-4`}
        buttonTitle={favouriteCategoryList?.create_permission && "Create"}
        handleClick={handleModal}
      ></HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: favouriteCategoryState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={true}
        />
        {favouriteCategoryList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={favouriteCategoryList?.data?.result || []}
            uniqueID={"id"}
            fields={favouriteCategoryList?.fields || {}}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleEdit={handleEditAction}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={favouriteCategoryState?.clearSelection}
            perpage={favouriteCategoryState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={favouriteCategoryList?.edit_permission}
            showCheckBox={favouriteCategoryList?.edit_permission}
          />
        )}

        {favouriteCategoryList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={favouriteCategoryState?.currentPage}
            totalPageCount={Math.ceil(
              favouriteCategoryList?.data?.total_count /
                favouriteCategoryState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === favouriteCategoryState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={favouriteCategoryList?.fields || []}
              moduleId={favouriteCategoryList?.module_id}
              updateData={updateFavouriteCategoryTableHeadData}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={favouriteCategoryState?.showModal}
          handleClose={handleModal}
          title={
            favouriteCategoryState?.isEdit
              ? "Update Favourite Category Icon"
              : "Add Favourite Category Icon"
          }
          backdrop={"static"}
        >
          <AddFavouriteCategory
            refetch={refetch}
            handleModal={handleModal}
            favouriteCategoryState={favouriteCategoryState}
            setFvouriteCategoryState={setFvouriteCategoryState}
          />
        </OffCanvasLayout>
        <ModalLayout
          show={favouriteCategoryState?.showImageModal}
          handleClose={closeImageModal}
          // backdrop="static"
        >
          <ImageCard
            data={favouriteCategoryState?.imageData}
            handleClose={closeImageModal}
          />
        </ModalLayout>
      </div>
    </>
  );
};

export default FavouriteCategory;
